import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import DashboardSidebar from '@/components/dashboardSidebar/dashboardSidebar.vue';
import DashboardSidebarMobile from '@/components/dashboardSidebarMobile/dashboardSidebarMobile.vue';

@Component({
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm) => {
      if(vm.getIsToken && !vm.getSubscription) {
        next('/mi-menu/comenzar');
      } else {
        next();
      }
    });
  },
  components:{
    DashboardSidebar,
    DashboardSidebarMobile
  }

})
export default class SubscriptionHistory extends Vue {

 
  pedidos = [
    {
      id: 1,
      number: '000000',
      date: '00 Mes, AA',
      status: 'Abierto',
      color: 'yellow',
      description: '00x Almuerzos 00x Cenas 00x Snacks 00x Batidos',
      total: '$000.000'
    },
    {
      id: 2,
      number: '000000',
      date: '00 Mes, AA',
      status: 'Confirmado',
      color: 'green',
      description: '00x Almuerzos 00x Cenas 00x Snacks 00x Batidos',
      total: '$000.000'
    },
    {
      id: 3,
      number: '000000',
      date: '00 Mes, AA',
      status: 'Saltado',
      color: 'red',
      description: '00x Almuerzos 00x Cenas 00x Snacks 00x Batidos',
      total: '$000.000'
    },
    {
      id: 4,
      number: '000000',
      date: '00 Mes, AA',
      status: 'Abierto',
      color: 'yellow',
      description: '00x Almuerzos 00x Cenas 00x Snacks 00x Batidos',
      total: '$000.000'
    },
    {
      id: 5,
      number: '000000',
      date: '00 Mes, AA',
      status: 'Confirmado',
      color: 'green',
      description: '00x Almuerzos 00x Cenas 00x Snacks 00x Batidos',
      total: '$000.000'
    },
    {
      id: 6,
      number: '000000',
      date: '00 Mes, AA',
      status: 'Saltado',
      color: 'red',
      description: '00x Almuerzos 00x Cenas 00x Snacks 00x Batidos',
      total: '$000.000'
    }
  ];

}
